import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  IDLE,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { CHANGE_SURVEY_STATUS } from './constants';
import {
  PublishSurveySuccess,
  PublishSurveyError,
  PublishSurveyDataActionTypes,
  PublishSurveyState,
} from './types';

const initialState: PublishSurveyState = {
  status: idle,
  entities: null,
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: PublishSurveyDataActionTypes,
  ): PublishSurveyState => {
    switch (action.type) {
      case CHANGE_SURVEY_STATUS + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case CHANGE_SURVEY_STATUS + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as PublishSurveySuccess).payload;
        break;
      }
      case CHANGE_SURVEY_STATUS + FAILURE: {
        draft.status = rejected;
        draft.error = (action as PublishSurveyError).error;
        break;
      }
      case CHANGE_SURVEY_STATUS + IDLE: {
        draft.status = idle;
        break;
      }
      default:
        return draft;
    }
  },
);
